
import request from '@/utils/request'

/*
    统计指标查询接口，车辆信息 https://mock-test.cheweijia.com/project/10282/interface/api/492359
*/
export function getCar(
  deptId, // 部门id，默认是当前人所属部门
  sub, // 是否是查询子级，默认否，查询当前部门
) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/dashboard/workbench/car',
    method: 'post',
    data: {
      deptId,
      sub,
    },
  })
}
/*
    统计指标查询接口，财务信息 https://mock-test.cheweijia.com/project/10282/interface/api/492361
*/
export function getFinance(
  deptId, // 部门id，默认是当前人所属部门
  sub, // 是否是查询子级，默认否，查询当前部门 1：是
) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/dashboard/workbench/finance',
    method: 'post',
    data: {
      deptId,
      sub,
    },
  })
}

// -------------------------------待办-----------------------------------
/* 首页 - 我的待办 列表 */
export function getIndexTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/index',
    method: 'POST',
    data,
  })
}

/* 待办中心 - 待办列表（已处理、未处理） */
export function getCenterTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/getDealWithList',
    method: 'POST',
    data,
  })
}

/* 待办管理 - 列表 */
export function getConfigTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/list',
    method: 'POST',
    data,
  })
}


/* 待办管理 创建 */
export function addConfigTodo(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/add',
    method: 'POST',
    data,
  })
}

/* 待办管理 更新 */
export function updateConfigTodo(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/update',
    method: 'POST',
    data,
  })
}

/* 待办管理 详情 */
export function configTodoDetail(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/detail',
    method: 'POST',
    data,
  })
}

/* 待办管理 启用、禁用 */
export function configTodoSwitchStatus(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/switchStatus',
    method: 'POST',
    data,
  })
}

// --------------------------------------------------------------数据报表----------------------------------、
export function postStatOrder(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/order',
    method: 'post',
    data,
  })
}


// 运营统计数据
export function postStatOperation(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/operation',
    method: 'post',
    data,
  })
}

// 经营分析统计数据
export function postStatManage(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/manage',
    method: 'post',
    data,
  })
}
// 6：财务分析统计数据：
export function postStartFinance(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/finance',
    method: 'post',
    data,
  })
}
// 车辆全部数据
export function postStatCar(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/car',
    method: 'post',
    data,
  })
}
// 车辆可租不可租
export function postStatStandard(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/stat/standard',
    method: 'post',
    data,
  })
}

// 资金回款-总览接口
export function getFundsOverview(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/dashboard/overview',
    method: 'post',
    data,
  })
}

// 资金回款-折线图
export function getFundsLineChart(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/dashboard/line/overview',
    method: 'post',
    data,
  })
}

// 资金回款-导出
export function exportFunds(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/dashboard/export',
    method: 'post',
    data,
  })
}
